'use strict';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import deLocale from 'dayjs/locale/de';
dayjs.extend(customParseFormat);

declare global {
  interface Window {
    en: boolean;
    dayJS: typeof dayjs;
  }
}

if (!en) {
  dayjs.locale(deLocale);
}

window.dayJS = dayjs;

const dateFormat = en ? 'dddd, MM/DD/YYYY' : 'dddd[, dem ]DD.MM.YYYY';
const timeFormat = en ? 'h:mm A' : 'H:mm[ Uhr]';
const dataTransferFormat = 'YYYY-MM-DD';

export const getFormattedDate = (date: Date | string) => dayjs(date).format(dateFormat);

export const getFormattedTime = (date: Date | string) => dayjs(date).format(timeFormat);

export const getAgeFromDoB = (dateOfBirth: string) => {
  return dayjs().diff(dayjs(dateOfBirth, dataTransferFormat), 'year');
};

export const getYearOfBirth = (dateOfBirth: string) => {
  return dayjs(dateOfBirth, dataTransferFormat).year();
};

export const getDateFromAge = (age: number) => {
  return dayjs().subtract(age, 'years').format(dataTransferFormat);
};

export const getYobFromAge = (age: number) => {
  return dayjs().subtract(age, 'years').year();
};

export const isFormattedDate = (dateString: string) => {
  return dayjs(dateString, dataTransferFormat, true).isValid();
};

export const getFirstOfNextMonth = () => {
  return dayjs().date(1).add(1, 'month').format(dataTransferFormat);
};

export function getIngressDate(): string {
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
}
